module.exports = {
          srcSet: __webpack_public_path__ + "images/1899-d9d1cb00ad4ff7b8346f38bc45acf05a-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1899-2ac9d4fd08c5e18e9a21078a4e39433e-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1899-d9d1cb00ad4ff7b8346f38bc45acf05a-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1899-2ac9d4fd08c5e18e9a21078a4e39433e-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1899-d9d1cb00ad4ff7b8346f38bc45acf05a-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1899-d9d1cb00ad4ff7b8346f38bc45acf05a-320.jpg"},
          
          width: 320,
          height: 251
        }